import { user } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  REQUEST_GET_USER_PROFILE,
  REQUEST_GET_USER_PROFILE_START,
  REQUEST_GET_USER_PROFILE_COMPLETE,
  REQUEST_GET_USER_PROFILE_ERROR,
  SUBMIT_COMPLAINT,
  SUBMIT_COMPLAINT_START,
  SUBMIT_COMPLAINT_COMPLETE,
  SUBMIT_COMPLAINT_ERROR,
  UPDATE_PROFILE_INFO,
  UPDATE_PROFILE_INFO_START,
  UPDATE_PROFILE_INFO_COMPLETE,
  UPDATE_PROFILE_INFO_ERROR,
  setUserStatusUnauthorised,
  SUBMIT_FINCH_ACCESS_TOKEN,
  SUBMIT_FINCH_ACCESS_TOKEN_START,
  SUBMIT_FINCH_ACCESS_TOKEN_COMPLETE,
  SUBMIT_FINCH_ACCESS_TOKEN_ERROR,
} from './actions';
import orderFormErrorStr from '../../../constants/errorStrings';

export function* getUserProfile() {
  try {
    yield put({
      type: REQUEST_GET_USER_PROFILE_START,
    });
    const { response, error } = yield call(user.userProfile);

    if (!!response) {
      yield put({
        type: REQUEST_GET_USER_PROFILE_COMPLETE,
        payload: {
          data: response,
        },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetUserProfileError({
            error: error?.data.message
              ? error?.data.message
              : orderFormErrorStr.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetUserProfileError({
        error: orderFormErrorStr.commonError,
      }),
    );
  }
}

export function* updateUserProfile({ payload: { params, successCallback } }) {
  try {
    yield put({
      type: UPDATE_PROFILE_INFO_START,
    });
    const { response, error } = yield call(user.updateProfile, {
      params,
    });

    if (!!response) {
      yield put({
        type: UPDATE_PROFILE_INFO_COMPLETE,
        payload: {
          data: response,
        },
      });
      yield call(successCallback);
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onUpdateUserProfileError({
            error: error?.data.message
              ? error?.data.message
              : orderFormErrorStr.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onUpdateUserProfileError({
        error: orderFormErrorStr.commonError,
      }),
    );
  }
}

export function* submitComplaint({ payload: { params, successCallback } }) {
  try {
    yield put({
      type: SUBMIT_COMPLAINT_START,
    });
    const { response, error } = yield call(user.submitComplaint, {
      params,
    });

    if (!!response) {
      yield put({
        type: SUBMIT_COMPLAINT_COMPLETE,
      });
      yield call(successCallback);
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onSubmitComplaintError({
            error: error?.data.message
              ? error?.data.message
              : orderFormErrorStr.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onSubmitComplaintError({
        error: orderFormErrorStr.commonError,
      }),
    );
  }
}

export function* submitFinchAccessToken({ payload: { params, successCallback } }) {
  try {
    yield put({
      type: SUBMIT_FINCH_ACCESS_TOKEN_START,
    });

    yield delay(1000);
    const { response, error } = yield call(user.submitFinchAccessToken, {
      params,
    });

    if (!!response) {
      yield put({
        type: SUBMIT_FINCH_ACCESS_TOKEN_COMPLETE,
      });
      yield call(successCallback);
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onSubmitFinchAccessTokenError({
            error: error?.data.message
              ? error?.data.message
              : orderFormErrorStr.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onSubmitFinchAccessTokenError({
        error: orderFormErrorStr.commonError,
      }),
    );
  }
}

const onSubmitFinchAccessTokenError = (payload = {}) => ({
  type: SUBMIT_FINCH_ACCESS_TOKEN_ERROR,
  payload,
});

const onGetUserProfileError = (payload = {}) => ({
  type: REQUEST_GET_USER_PROFILE_ERROR,
  payload,
});

const onUpdateUserProfileError = (payload = {}) => ({
  type: UPDATE_PROFILE_INFO_ERROR,
  payload,
});

const onSubmitComplaintError = (payload = {}) => ({
  type: SUBMIT_COMPLAINT_ERROR,
  payload,
});


function* watchUpdateUserProfile() {
  yield takeLatest(UPDATE_PROFILE_INFO, updateUserProfile);
}

function* watchRequestUserProfile() {
  yield takeLatest(REQUEST_GET_USER_PROFILE, getUserProfile);
}

function* watchSubmitComplaint() {
  yield takeLatest(SUBMIT_COMPLAINT, submitComplaint);
}

function* watchSubmitFinchAccessToken() {
  yield takeLatest(SUBMIT_FINCH_ACCESS_TOKEN, submitFinchAccessToken);
}

export const sagas = [
  watchRequestUserProfile,
  watchSubmitComplaint,
  watchUpdateUserProfile,
  watchSubmitFinchAccessToken,
];
